<template>
    <div class="popup" v-if="isShow" id="freeSaledPopup">
        <div class="freesale-content freesale-content-default" v-if="type==1">
            <div class="default-close freesale-close" @click="saveTag(0)"></div>
            <div class="freesale-body">
                <div style="height:228px;">
                    <h2 v-html="$t('language.popup.freeSaledPopup.popupTitle')"></h2>
                </div>
                <div class="freesale-tips" v-html="$t('language.popup.freeSaledPopup.tips1')"></div>
                <div class="freesale-btns">
                    <button @click="saveTag(1)" v-loading='isLoading==2'>{{$t('language.popup.freeSaledPopup.btns1')}}</button>
                    <a @click="type=2">{{$t('language.popup.freeSaledPopup.btns2')}}</a>
                </div>
            </div>
        </div>
        <div class="freesale-content freesale-content-wait" v-if="type==2">
            <div class="default-close freesale-close" @click="saveTag(0)"></div>
            <div class="freesale-body">
                <div class="freesale-title"><img :src="require('../../../assets/images/saleActive/love-emoji.svg')">&nbsp;{{$t('language.popup.freeSaledPopup.tips2')}}</div>
                <div class="freesale-tips">{{$t('language.popup.freeSaledPopup.tips3')}}</div>
                <div class="freesale-btns">
                    <button @click="saveTag(1)" v-loading='isLoading==2'>{{$t('language.popup.freeSaledPopup.btns1')}}</button>
                    <button @click="saveTag(2)" v-loading='isLoading==3' class="transparent-button">{{$t('language.common.skip')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function() {
        return {
            isShow: false,
            type: 1,//1是普通窗口，2是提醒窗口
            FREE_SALED_NAME: commonstate.freeSaledName,
            isLoading: 0,
        }
    },
    methods: {
        saveTag(type) {
            if(this.isLoading!=0)return;

            //保存标记 0：只关闭，1：获取流量，2：跳过该活动
            this.isLoading = type + 1;
            let user = commonUtils.getUser();
            if(!user.vip || user.payLevel !=1) {
                //没有活动标记可以获取流量
                let date = {
                    ud: user.id,
                    tag: this.FREE_SALED_NAME,
                    message: type,
                };
                this.Utils.doAcvieTagRequest("gift_traffic_tag", date).then(res => {
                    if (res.code == 200) {
                        //更新信息
                        commonUtils.getAllActiveTagByUser();
                        if(type==1) {
                            //更新用户流量信息
                            let that = this;
                            commonUtils.refreshUserInfo(this.$parent,function(res) {
                                that.isLoading = 0;
                                that.isShow = false;
                                that.$parent.isShow = false;
                                that.$toast({
                                    text: that.$t('language.popup.freeSaledPopup.success'),
                                    type: 'success',
                                    idValue: "rightContBan",
                                });
                            });
                        }else {
                            this.isShow = false;
                            this.isLoading = 0;
                            if(type==2) {
                                this.$parent.isShow = false;
                            }
                        }
                    } else if (res.code == 400 && res.reson) {
                        this.$toast({
                            text: this.$t('language.exception.' + res.reson),
                            type: 'fail',
                            idValue: "rightContBan",
                        });
                    } else {
                        this.$toast({
                            text: 'Unknown error!',
                            type: 'fail',
                            idValue: "rightContBan",
                        });
                    }
                });
            }

            if(type==0) {
                this.isShow = false;
            }
        }
    }
}
</script>

<style lang="less" scoped>
#freeSaledPopup {
    font-family: Arial;
    font-size: 16px;/*no*/
    font-weight: normal;
    line-height: 140%;
    text-align: center;
    letter-spacing: 0em;
}

.freesale-content {
    width: 440px;/*no*/
    height: 518px;/*no*/
    box-sizing: border-box;
    position: absolute;
    margin: auto;
    border-radius: 32px;/*no*/
    z-index: 600;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
    &.freesale-content-default {
        .freesale-body {
            background-image: url('../../../assets/images/valentineSaled-2026/free-bg.png');
            background-size: 100% auto;
            h2 {
                font-family: Alibaba PuHuiTi 2.0;
                font-weight: 700;
                font-size: 35px;/*no*/
                font-variation-settings: "opsz" auto;
                color: #FFFFFF;
                white-space: nowrap;
                /deep/ span {
                    color: #F6592B;
                    font-weight: 900;
                    font-size: 40px;/*no*/
                }
            }
        }
    }
    &.freesale-content-wait {
        height: 246px;/*no*/
        .freesale-close {
            top: -3.5px;/*no*/
            right: -8px;/*no*/
        }
        .freesale-btns {
            display: flex;
            gap: 16px;/*no*/
            button {
                width: 50%;
                margin: 0;
            }
        }
        .freesale-body {
            box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.5);/*no*/
            background: linear-gradient(180deg, #FF6E61 0%, #FFFFFF 69%), linear-gradient(180deg, #FFEE98 0%, #FFFFFF 100%);
        }
    }
}

.freesale-close {
    right: -14px;/*no*/
    top: -11px;/*no*/
    width: 40px;/*no*/
    height: 40px;/*no*/
    font-size: 20px;/*no*/
    line-height: 40px;/*no*/
}

.freesale-body {
    width: calc(100% - 60px);/*no*/
    height: calc(100% - 60px);/*no*/
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 10px;/*no*/
    border-radius: 32px;/*no*/
    padding: 30px;/*no*/
    box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.5);/*no*/
    .freesale-title {
        font-size: 20px;/*no*/
        font-weight: bold;
    }
    .freesale-tips {
        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #000000;
    }
    .freesale-btns {
        width: 100%;
        button {
            width: 100%;
            height: 48px;/*no*/
            border-radius: 48px;/*no*/
            background: linear-gradient(177deg, #FA774A 2%, #EE383B 86%), #FF691F;;
            margin-bottom: 18px;/*no*/
            &.transparent-button {
                background: transparent;
                border: 1px solid #999999;
                color: #333333;
            }
            /deep/.el-loading-mask {
                border-radius: 48px;/*no*/
            }
        }
        a {
            color: #666666;
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/components/popup/upgrade_popups/free_saled_popup.vue